// @flow
import React from 'react';
import NotificationItem from './NotificationItem';

type Props = {
    notificationsList: array<any>
};

const NotificationsCenterList = ({ notificationsList }: Props) => {
    const notifications = notificationsList.map((id: number) => {
        return <NotificationItem key={`notification-${id}`} id={id} />;
    });
    return <ul className="notifications-list">{notifications}</ul>;
};

export default NotificationsCenterList;
